<template>
<v-dialog v-model="dialog" width="500px">
  <v-card>
    <v-card-title class="warning headline" style="font-weight:bold; color:white">Confirm Delete</v-card-title>
    <v-card-text>Are you sure you want to remove Sales partner {{inpt.inpt_code}} {{inpt.inpt_naam}} ?</v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="warning mx-2" small @click="rmInpt">Yes</v-btn>
      <v-btn color="success"  small @click="dialog = false">No</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      inpt_encrid: null,
      inpt: {}
    }
  },
  methods: {
    open(inpt_encrid) {
      this.$emit("showSnackbar");
      this.dialog = true;
      this.$axios
        .post("ares/json/ares/task/inpt/getInptToRmInpt.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getInptToRmInpt"
          },
          getInptToRmInpt: {
            inpt_encrid: inpt_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.inpt = res.data.getInptToRmInpt;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    rmInpt() { 
      this.$axios
        .post("ares/json/ares/task/inpt/rmInpt.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "rmInpt"
          },
          rmInpt: {
            inpt_encrid: this.inpt.inpt_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else { 
            setTimeout(() => { opener.location.reload();  window.close(); }, 2000);   
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.rmInpt.text,
              color: res.data.rmInpt.color
            });
            
            this.dialog = false;
          }
        })
    },
  }
}
</script>

